import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { CircularProgress } from "material-ui";
import CurrentWebinars from "./CurrentWebinars/CurrentWebinars";
import UpcomingWebinars from "./UpcomingWebinars/UpcomingWebinars";
import PreviousWebinars from "./PreviousWebinars/PreviousWebinars";
import ZoomInfo from "./ZoomInfo";
import actions from "actions";
import constants from "constants";
import DisciplineTagSelect from "containers/Input/DisciplineTagSelect";

const ALL = "All";

const {
  loadClientWebinarsSaga,
  loadSubscriptionsSaga,
  cleanWebinars,
  reloadDashboardWebinars,
  loadSponsorsSuggestionsSaga,
  setWebinars,
  loadClientUrlsSaga,
} = actions;

const {
  UPCOMING_CLIENT_WEBINARS,
  CURRENT_CLIENT_WEBINARS,
  PREVIOUS_CLIENT_WEBINARS,
} = constants;

class ClientUrlDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTo: null,
      webinars: [1, 2, 3],
      page: {
        upcoming: 1,
        current: 1,
        previous: 1,
      },
      active: "",
      sponsor: ALL,
      disciplines: [],
    };

    this.timeout = null;
  }

  componentWillMount() {
    const slug = this.props.params.slug;
    this.props.loadClientUrls();
    this.props.loadClientWebinars(UPCOMING_CLIENT_WEBINARS, slug, 1);
    // this.props.loadClientWebinars(CURRENT_CLIENT_WEBINARS, slug, 1);
    this.props.loadClientWebinars(PREVIOUS_CLIENT_WEBINARS, slug, 1);
  }

  componentDidMount() {
    if (this.props.location.query.scrollTo) {
      const index = this.props.upcoming.values.findIndex(
        (item) => item.id == this.props.location.query.scrollTo
      );
      if (index < 0) () => ({});
    }
    this.chekTime();
  }

  componentWillReceiveProps = (nextState) => {
    const { upcoming } = this.props;

    if (
      nextState.upcoming.count > this.props.upcoming.count &&
      this.props.location.query.scrollTo
    ) {
      const index = nextState.upcoming.values.findIndex(
        (item) => item.id == this.props.location.query.scrollTo
      );

      if (index < 0) this.nextPage(UPCOMING_CLIENT_WEBINARS);
      else
        this.setState((prev) => ({
          ...prev,
          scrollTo: this.props.location.query.scrollTo,
        }));
    }

    if (upcoming.values.length !== nextState.upcoming.values.length) {
      this.chekTime();
    }
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
    clearInterval(this.timeout);
  }

  checkWebinar = () => {
    const { upcoming, setWebinars } = this.props;

    if (moment().isSameOrAfter(moment(upcoming.values[0].start_date))) {
      setWebinars(CURRENT_CLIENT_WEBINARS, [upcoming.values[0]], 1);
      clearInterval(this.timeout);
    }
  };

  chekTime = () => {
    const { current, upcoming } = this.props;

    if (current.count === 0 && upcoming.values[0] && !this.timeout) {
      this.timeout = setInterval(this.checkWebinar, 3000);
    }
  };

  reloadWebinars = () => {
    const params = this.webinarParams();
    const slug = this.props.params.slug;
    this.props.loadClientWebinars(UPCOMING_CLIENT_WEBINARS, slug, 1, params);
    // this.props.loadClientWebinars(CURRENT_CLIENT_WEBINARS, slug, 1, params);
    this.props.loadClientWebinars(PREVIOUS_CLIENT_WEBINARS, slug, 1, params);
  };

  webinarParams = () => {
    // Only return group_id if it exists in props or state
    // All other filtering is now handled by the backend via the scope parameter
    const group_id = this.props.group_id || this.state.group_id;
    return group_id ? { group_id } : {};
  };

  setReloadInterval = () => {
    this.reloadInterval = setInterval(() => {
      this.reloadWebinars();
    }, 60000);
  };

  clearReloadInterval = () => {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  };

  nextPage = (webinarType) => {
    const params = this.webinarParams();
    const slug = this.props.params.slug;
    switch (webinarType) {
      case UPCOMING_CLIENT_WEBINARS:
        this.setState(
          {
            page: {
              ...this.state.page,
              upcoming: this.state.page.upcoming + 1,
            },
          },
          () =>
            this.props.loadClientWebinars(
              UPCOMING_CLIENT_WEBINARS,
              slug,
              this.state.page.upcoming,
              params
            )
        );
        break;
      case CURRENT_CLIENT_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, current: this.state.page.current + 1 },
          },
          () =>
            this.props.loadClientWebinars(
              CURRENT_CLIENT_WEBINARS,
              slug,
              this.state.page.current,
              params
            )
        );
        break;
      case PREVIOUS_CLIENT_WEBINARS:
        this.setState(
          {
            page: {
              ...this.state.page,
              previous: this.state.page.previous + 1,
            },
          },
          () =>
            this.props.loadClientWebinars(
              PREVIOUS_CLIENT_WEBINARS,
              slug,
              this.state.page.previous,
              params
            )
        );
        break;
    }
  };

  changeActiveLink = (val) =>
    this.setState({
      active: val,
    });

  sponsorSuggestions = () => {
    const { sponsorOptions } = this.props;
    const sponsors = sponsorOptions.map((sponsor) => ({
      value: sponsor.id,
      label: sponsor.title,
    }));

    return [...sponsors, { label: ALL, value: ALL }];
  };

  onFilterChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        page: {
          upcoming: 1,
          current: 1,
          previous: 1,
        },
      },
      this.reloadWebinars
    );
  };

  onDisciplinesChange = (disciplines) => {
    this.setState(
      {
        disciplines: (disciplines || []).map((discipline) => discipline.value),
        page: {
          upcoming: 1,
          current: 1,
          previous: 1,
        },
      },
      this.reloadWebinars
    );
  };

  renderFilters = () => {
    if (this.props.sponsor) {
      return null;
    }

    return (
      <div className="section_webinars_sponsors_filter">
        <DisciplineTagSelect
          onChange={this.onDisciplinesChange}
          value={this.state.disciplines}
        />
      </div>
    );
  };

  renderTitle = () => {
    const {
      params: { slug },
      clientUrl,
    } = this.props;
    const clientUrlItem = clientUrl.find((url) => url.slug === slug);
    const title = clientUrlItem ? clientUrlItem.name : slug;

    return <h4 className="webinars_main_title">{title}</h4>;
  };

  render() {
    const { isLoading } = this.props;

    return (
      <main className="site--width">
        <ZoomInfo />
        <div className="section_webinars">
          {this.renderTitle()}
          <ul className="section_webinars_list ">
            {/* <li className="section_webinars_list_item tab">
              <a
                className={this.state.active == "current" && "active"}
                href="#current"
                onClick={() => this.changeActiveLink("current")}
              >
                CURRENT MEETINGS
              </a>
            </li> */}
            <li className="section_webinars_list_item tab">
              <a
                href="#upcoming"
                onClick={() => this.changeActiveLink("upcoming")}
                className={this.state.active == "upcoming" && "active"}
              >
                UPCOMING MEETINGS
              </a>
            </li>
            <li className="section_webinars_list_item tab">
              <a
                href="#previous"
                onClick={() => this.changeActiveLink("previous")}
                className={this.state.active == "previous" && "active"}
              >
                RECORDED MEETINGS
              </a>
            </li>
          </ul>
          {this.renderFilters()}
        </div>
        {/* <CurrentWebinars
          webinars={this.props.current.values}
          nextPage={() => this.nextPage(CURRENT_CLIENT_WEBINARS)}
          page={this.state.page.current}
          count={this.props.current.count}
          onRefreshWebinars={this.reloadWebinars}
        /> */}
        <UpcomingWebinars
          webinars={this.props.upcoming.values}
          nextPage={() => this.nextPage(UPCOMING_CLIENT_WEBINARS)}
          page={this.state.page.upcoming}
          count={this.props.upcoming.count}
          scrollTo={this.state.scrollTo}
          slug={this.props.params.slug}
        />
        <PreviousWebinars
          webinars={this.props.previous.values}
          nextPage={() => this.nextPage(PREVIOUS_CLIENT_WEBINARS)}
          page={this.state.page.previous}
          count={this.props.previous.count}
          sponsor={this.state.sponsor}
          sponsors={this.sponsorSuggestions()}
          onFilterChange={this.onFilterChange}
        />
        {isLoading && (
          <div className="dashboard-loader">
            <CircularProgress />
            <p>Reloading...</p>
          </div>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  upcoming: state.clientUrls.list.upcoming,
  current: state.clientUrls.list.current,
  previous: state.clientUrls.list.previous,
  clientUrl: state.clientUrls.list.values,
  // sponsorOptions: state.suggestions.sponsor.values,
  sponsorOptions: state.sponsors.list.values,
  isLoading: state.webinars.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  loadClientWebinars: (scope, slug) =>
    dispatch(loadClientWebinarsSaga(scope, slug)),
  loadSubscriptions: () => dispatch(loadSubscriptionsSaga()),
  cleanWebinars: () => dispatch(cleanWebinars()),
  reloadDashboardWebinars: (params) =>
    dispatch(reloadDashboardWebinars(params)),
  loadSponsorsSuggestions: () => dispatch(loadSponsorsSuggestionsSaga()),
  setWebinars: (webinarsType, webinars, count) =>
    dispatch(setWebinars(webinarsType, webinars, count)),
  loadClientUrls: () => dispatch(loadClientUrlsSaga()),
});
export default connect(mapStateToProps, mapDispatchToProps)(ClientUrlDashboard);



// WEBPACK FOOTER //
// ./src/containers/ClientUrlDashboard/Dashboard.js